<ul class="context-actions">
  <li><a (click)="manage.emit()"><i class="far fa-cog"></i></a></li>
  <li *ngIf="!hasEntries || !elementId"><a (click)="remove.emit()"><i class="far fa-trash"></i></a></li>
  <li><a (click)="moveUp.emit()"><i class="far fa-angle-up"></i></a></li>
  <li><a (click)="moveDown.emit()"><i class="far fa-angle-down"></i></a></li>
</ul>
